<template>
  <span
    ref="span"
    :data-html="truncatedText"
    class="sm-text-truncate"
    :class="[
      classes,
      {
        'show-hint': truncatedText,
      },
    ]"
    :style="{
      maxWidth: maxWidth,
    }"
    @mousemove="checkHintPosition"
    @mouseleave="stopListeningToScroll"
    @mouseover="listenToScroll"
    >{{ text }}</span
  >
</template>

<script>
export default {
  name: "text-truncate",
  props: {
    text: {
      type: String,
      default: "",
    },
    maxWidth: {
      type: String,
      default: "100%",
    },
    classes: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      truncatedText: null,
      top: 0,
      span: null,
      lastTop: 0,
    };
  },
  mounted() {
    this.span = this.$refs.span;
    this.showHintIf();
  },
  methods: {
    checkHintPosition(e) {
      if (!this.span || !this.truncatedText) return;

      let rect = this.span.getBoundingClientRect();
      this.span.style.setProperty("--before-top", `${rect.top}px`);
    },
    showHintIf() {
      if (this.span.offsetWidth < this.span.scrollWidth) {
        this.truncatedText = this.text;
      } else {
        this.truncatedText = null;
      }
    },
    hideHint() {
      this.truncatedText = null;
    },
    listenToScroll() {
      window.addEventListener("scroll", this.hideHint);
      this.showHintIf();
    },
    stopListeningToScroll() {
      window.removeEventListener("scroll", this.hideHint);
      if (this.span.offsetWidth < this.span.scrollWidth) {
        this.truncatedText = this.text;
      }
    },
  },
};
</script>

